import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const StatusBadge = ({ status }) => {
  const map = {
    "Now Selling": "bg-[#6E7765] text-[#FDFBF7]",
    Enquire: "bg-[#C19A6B] text-[#1A1A1A]",
    "Sold Out": "bg-[#5C5C5C] text-[#FDFBF7]",
  };
  return (
    <span className={`overline px-3 py-1.5 ${map[status] || "bg-[#C19A6B] text-[#1A1A1A]"}`}>
      {status}
    </span>
  );
};

export const ProjectCard = ({ project, index = 0 }) => (
  <Link
    to={`/projects/${project.slug}`}
    data-testid={`project-card-${project.slug}`}
    className="group block"
  >
    <div className="img-zoom-wrap relative border border-[#E5DFD3]">
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={project.cover}
          alt={`${project.name} - ${project.location}`}
          loading="lazy"
          className="img-zoom w-full h-full object-cover"
        />
      </div>
      <div className="absolute top-4 left-4">
        <StatusBadge status={project.status} />
      </div>
      <div className="absolute bottom-4 right-4 w-11 h-11 rounded-full bg-[#FDFBF7] flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
        <ArrowUpRight size={18} className="text-[#1A1A1A]" />
      </div>
    </div>
    <div className="pt-5 flex items-start justify-between gap-4">
      <div>
        <p className="overline text-[#C19A6B]">{project.city}</p>
        <h3 className="font-serif-lux text-3xl text-[#1A1A1A] mt-2 leading-none">{project.name}</h3>
        <p className="font-sans-lux text-sm text-[#5C5C5C] mt-2">{project.location}</p>
      </div>
      <p className="font-sans-lux text-sm text-[#1A1A1A] text-right whitespace-nowrap">{project.type.split("·")[0]}</p>
    </div>
  </Link>
);
